import { render } from "./FrecuentAccessComponent.vue?vue&type=template&id=609652aa&scoped=true"
import script from "./FrecuentAccessComponent.vue?vue&type=script&lang=js"
export * from "./FrecuentAccessComponent.vue?vue&type=script&lang=js"

import "./FrecuentAccessComponent.vue?vue&type=style&index=0&id=609652aa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609652aa"]])

export default __exports__